import moment from 'moment';
import { Instance } from 'mobx-state-tree';
import { ScannedPackageDtoModelBase } from './ScannedPackageDtoModel.base';
import getAppRoot from '../utils/getAppRoot';
import getFormattedTime from '../../../helpers/getFormattedTime';
import getFormattedDate from '../../../helpers/getFormattedDate';

/* The TypeScript type of an instance of ScannedPackageDtoModel */
export interface ScannedPackageDtoModelType extends Instance<typeof ScannedPackageDtoModel.Type> {}

/* A graphql query fragment builders for ScannedPackageDtoModel */
export { selectFromScannedPackageDto, scannedPackageDtoModelPrimitives, ScannedPackageDtoModelSelector } from './ScannedPackageDtoModel.base';

/**
 * ScannedPackageDtoModel
 */
export const ScannedPackageDtoModel = ScannedPackageDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }))
  .views(self => ({
    get scannedTimeString(): string | undefined {
      return getFormattedTime(moment(self.scannedTime), getAppRoot(self).organization.settings.dateTimeFormat);
    },
    get scannedDateString(): string | undefined {
      return getFormattedDate(self.scannedTime);
    },
  }));
